module.exports = __webpack_public_path__ + "img/header-engagementRings025Carat.8e14878.webp";